import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { ElementRef } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DotCMSEditableTextComponent } from '@dotcms/angular';
import { getUVEState } from '@dotcms/uve';
import { Observable, combineLatest, map } from 'rxjs';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { BlogContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { DotCmsCodecEncodePipe } from '../../../pipes/dot-cms-codec-encode.pipe';
import { isInsideCarousel } from '../../../utils/dot-cms-uve-utils';
import { DotCmsBlogAuthorComponent } from '../dot-cms-uve-blog-author/dot-cms-uve-blog-author.component';

@Component({
  selector: 'custom-dot-cms-blog-post',
  templateUrl: './dot-cms-uve-blog-post.component.html',
  styleUrls: ['./dot-cms-uve-blog-post.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    NgClass,
    AsyncPipe,
    ServerHtmlDirective,
    DotCmsBlogAuthorComponent,
    DatePipe,
    DotCMSEditableTextComponent,
    DotCmsCodecEncodePipe,
  ],
})
export class DotCmsBlogPostComponent implements OnInit {
  constructor(
    private elementRef: ElementRef // private gtmFacade: GoogleTagManagerFacade
  ) {}
  readonly contentlet = input<BlogContentlet>(undefined);
  isInCarousel: boolean;
  isExpanded = false;
  shouldShowReadMore = false;
  isInSideEditor: boolean;
  dotCmsUveFacade = inject(DotCmsUveFacade);
  host$: Observable<string>;

  ngOnInit(): void {
    this.isInCarousel = isInsideCarousel(this.elementRef.nativeElement);
    this.isInSideEditor = !!getUVEState();
    this.checksTeaserLength();
  }

  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
  }
  toggleContent(event: Event) {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;
  }

  checksTeaserLength() {
    const contentlet = this.contentlet();
    if (contentlet?.teaser && contentlet?.teaser.length > 0) {
      const maxLines = 3;
      const maxCharsPerLine = 60;
      const maxChars = maxLines * maxCharsPerLine;
      if (contentlet?.teaser.length > maxChars) {
        this.shouldShowReadMore = true;
      }
    }
  }

  buildImageSrc(): Observable<string> {
    return combineLatest([this.dotCmsUveFacade.getDotCmsHost$.pipe(whenTruthy())]).pipe(
      whenTruthy(),
      map(([host]) => `${host + this.contentlet().imageBlog.idPath}`)
    );
  }
}
